import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78a08d2d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-question" }, null, -1))

import { Placement } from 'element-plus'
import { EpPropMergeType } from 'element-plus/es/utils'
import { computed, PropType } from 'vue'


import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'InfoTooltip',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  content: {
    type: String,
  },
  popperClass: {
    type: String,
  },
  place: {
    type: String as PropType<EpPropMergeType<StringConstructor, Placement, unknown> | undefined>,
    default: 'top',
  },
  showAfter: {
    type: Number,
    default: 500,
  },
},
  setup(__props) {

const props = __props



const tooltipPopperClass = computed(() => `info-tooltip ${props.popperClass}`)

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createBlock(_component_el_tooltip, {
    effect: "dark",
    "popper-class": _unref(tooltipPopperClass),
    placement: __props.place,
    content: __props.content,
    "show-after": __props.showAfter
  }, _createSlots({
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 2
  }, [
    (_ctx.$slots.content)
      ? {
          name: "content",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "content")
          ])
        }
      : undefined
  ]), 1032, ["popper-class", "placement", "content", "show-after"]))
}
}

})